export default __webpack_public_path__ + "static/east-factory-b801f27365ba5310e10a2ef8e607b9be.jpg";